import type { OrderSummaryPageStore } from '../types';

export class RatingPromoCodesService {
  constructor(private pageStore: OrderSummaryPageStore) {}

  public api() {
    return {
      addPromoCode: (newCode: string) => this.addPromoCode(newCode),
      removePromoCode: (removedCode: string) => this.removePromoCode(removedCode),
    };
  }

  public data() {
    return {};
  }

  public handlers() {
    return {};
  }

  private addPromoCode(newCode: string) {
    const { pageStore } = this;
    const oldPromoCodes = pageStore.getState().ratingPayload?.toJson()?.newPromotionCodes || [];
    const codeAlreadyExists = pageStore.getState().ratingPayload?.hasPromotionCode(newCode) ?? false;

    pageStore.setState(({ ratingPayload: previousRatingPayload }) => {
      if (!previousRatingPayload) {
        return {};
      }

      // If the promo code already exists, use withNewPromotionCodes to force a new object reference.
      // This ensures Zustand detects a change and triggers a re-render, which causes React Query
      // to detect the query key change and refetch. This fixes the race condition where the rating
      // query completes before validation, returning data without promotion applied.
      if (codeAlreadyExists) {
        return {
          ratingPayload: previousRatingPayload.withNewPromotionCodes(oldPromoCodes),
        };
      }

      // If the code doesn't exist, use withAddedPromotionCode (normal flow)
      return {
        ratingPayload: previousRatingPayload.withAddedPromotionCode(newCode),
      };
    });
  }

  /**
   * Remove zero or more promo codes from the rating call request, along with any unapplied promo codes.
   */
  private removePromoCode(...removedCodes: string[]) {
    this.pageStore.setState(({ ratingPayload }) => ({
      ratingPayload: ratingPayload?.withRemovedPromotionCodes(...removedCodes),
    }));
  }
}
